// extracted by mini-css-extract-plugin
export default {"slider_wrapper":"VolumeSlider_slider_wrapper__wowRj"};